export class UserLogin {
  constructor(userID?: string, userName?: string, email?: string) {
    this.userID = userID;
    this.userName = userName;
    this.email = email;
  }

  public userID: string;
  public userName: string;
  public email: string;
}
